import PropTypes from 'prop-types';

const WidgetShell = ({
  title = null,
  action = null,
  children,
  className = '',
}) => {
  return (
    <section
      className={`rounded-2xl bg-on-surface/5 border border-on-surface/10 overflow-hidden ${
        className || ''
      }`}
    >
      {(title || action) && (
        <header className="flex items-center justify-between px-4 pt-3 pb-2">
          {title ? (
            <h3 className="text-on-surface font-semibold text-lg">{title}</h3>
          ) : (
            <span />
          )}
          {action ? <div>{action}</div> : null}
        </header>
      )}
      <div className="px-1 pb-2">{children}</div>
    </section>
  );
};

WidgetShell.propTypes = {
  title: PropTypes.node,
  action: PropTypes.node,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default WidgetShell;
